/*
 * O nome e o caminho da página de eventos, num módulo pequeno: quem só faz o
 * link não importa a página (que vem num chunk próprio).
 */
export const EVENTS_ROUTE = 'canela.events';
export const EVENTS_PATH = '/events';
flarum.reg.add('ramon-canela', 'forum/features/events/route', { EVENTS_ROUTE: EVENTS_ROUTE,EVENTS_PATH: EVENTS_PATH, });